import './PlayerHand.css';
import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import {useActions} from "../../../../hooks/useActions";
import {useDrop} from "react-dnd";

function PlayerPlaySpellDropZone() {


    const {isPlaySpellDrag, playerHand} = useTypedSelector(state => state.game);
    const {tutorial} = useTypedSelector(state => state.auth);
    const {setIsPlaySpellDrag, setPlayedCard, setPhase, playCard, setPlayerHand, setTutorial} = useActions();

    let rootClasses = 'playerPlaySpellDropZone';

    if (isPlaySpellDrag) {
        rootClasses += ' playerPlaySpellDropZoneActive'
    }
    const cardSpellDropped = (item) => {
        setIsPlaySpellDrag(false);
        const card = item.card;
        if (card.type_card === 'spell') {
            if (card.ability.need_select_target === 1) {
                setPlayedCard({card: card, handKey: item.handKey, target: null});
                setPhase('select_spell_target');

            } else {
                setPhase('play_card_progress');
                playCard({card: null, handKey: item.handKey, target: null});
            }
        }

        delete playerHand[item.handKey];
        setPlayerHand(playerHand);
        // Tutorial
        if (tutorial.step === 'PlaySpellCard70') {
            tutorial.step = 'SpellTarget75';
            setTutorial(tutorial);
        }
        //
    }

    const [, dropRef] = useDrop({
        accept: 'card_spell',
        drop: (item) => cardSpellDropped(item),
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })

    return <div ref={dropRef} className={rootClasses}></div>
}

export default PlayerPlaySpellDropZone;
